/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-explicit-any */
import styled, { keyframes } from "styled-components";

const slideIn = keyframes`
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-20px);
    opacity: 0;
  }
`;

const slideInAbove = keyframes`
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideOutAbove = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(20px);
    opacity: 0;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

export const Label = styled.div`
  color: #333333;
  font-size: 13px;
  margin-bottom: 10px;
  font-family: Inter;
`;

export const Container: any = styled.div`
  border-width: ${(props: any) => (props?.isFocused ? "2px" : "1px")};
  border-color: ${(props: any) => (props?.isFocused ? "#1976D2" : "#c0c0c0")};
  border-style: solid;
  height: 40px;
  border-radius: 12px;
  opacity: ${(props: any) => (props?.disabled ? 0.8 : 1)};
  overflow: hidden; /* Adicione esta linha */
`;

export const Input: any = styled.input`
  display: flex;
  width: 100%;
  height: 40px;
  padding: 0 16px;
  margin: 0;
  border: none;
  outline: none;
  box-shadow: none;
  background: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-size: 14px;
  font-family: Inter;
`;

export const Dropdown: any = styled.ul`
  position: absolute;
  width: 100%;
  max-height: ${(props: any) => props?.dropdownMaxHeight}px;
  border-radius: 4px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fff;
  font-family: Inter;
  z-index: 1;
  box-shadow: rgba(50, 50, 105, 0.15) 0px 2px 5px 0px,
    rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
  animation: ${({ isExiting, dropdownAbove }: any) =>
      isExiting
        ? dropdownAbove
          ? slideOutAbove
          : slideOut
        : dropdownAbove
        ? slideInAbove
        : slideIn}
    0.2s ease-in-out;
  transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
  top: ${({ dropdownAbove }: any) => (dropdownAbove ? "auto" : "100%")};
  bottom: ${({ dropdownAbove }: any) => (dropdownAbove ? "70%" : "auto")};

  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;

export const DropdownItem: any = styled.li`
  padding: 8px 12px;
  cursor: pointer;
  background-color: ${(props: any) =>
    props.selected ? "rgba(3, 127, 252, 0.1)" : "transparent"};
  color: ${(props: any) => (props.selected ? "rgba(3, 127, 252)" : "#333")};
  &:hover {
    background-color: ${(props: any) =>
      props.selected ? "rgba(3, 127, 252, 0.1)" : "#eee"};
  }
`;
